import { get, patch, post, remove } from 'vio-libs';
export function getUsers(organization, consumerAPI = false) {
    if (!consumerAPI) {
        return get(`users?organization=${organization}`);
    }
    return get(`v1/${organization}/users?expand=memberships.roles.permissions`, undefined, true);
}
export function postInviteUser(email, organization, roles, consumerAPI = false) {
    if (!consumerAPI) {
        return post(`users?organization=${organization}`, {
            data: {
                email,
                roles
            }
        });
    }
    return post(`v1/${organization}/memberships`, {
        data: {
            email,
            roles
        }
    }, true);
}
export function removeUser(organization, user, consumerAPI = false) {
    if (!consumerAPI) {
        return patch(`users?organization=${organization}`, {
            data: {
                action: 'remove_users',
                users: [user]
            }
        });
    }
    return remove(`v1/${organization}/memberships/${user}`, undefined, true);
}
export function removeUsers(organization, users) {
    return patch(`users?organization=${organization}`, {
        data: {
            action: 'remove_users',
            users
        }
    });
}
export function patchUserRoles(organization, email, roles, consumerAPI = false) {
    if (!consumerAPI) {
        return patch(`users?organization=${organization}`, {
            data: {
                action: 'set_roles',
                email,
                roles
            }
        });
    }
    return patch(`v1/${organization}/users`, {
        data: {
            email,
            roles
        }
    }, true);
}
export function patchUserAuthConnection(organization, email, authConnection) {
    return patch(`users?organization=${organization}`, {
        data: {
            action: 'set_auth_connection',
            auth_connection: authConnection,
            email
        }
    });
}
